import { IBreakEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateBreaksOpenShift", function updateBreaksOpenShift(breaks: IBreakEntity[]) {
    if (shiftEditorViewState().openShift) {
        shiftEditorViewState().openShift.breaks = breaks;
    }
});